import { HockeyPlayerLabelType } from "../../types";

export const getHockeyPlayerFDLabel = (playerId: number): string => {
  switch (playerId) {
    case 1:
      return "F1";
    case 2:
      return "F2";
    case 3:
      return "F3";
    case 4:
      return "D1";
    case 5:
      return "D2";
    case 6:
      return "G";

    default:
      return "F1";
  }
};

export const getHockeyPlayerLRLabel = (playerId: number): string => {
  switch (playerId) {
    case 1:
      return "LW";
    case 2:
      return "C";
    case 3:
      return "RW";
    case 4:
      return "LD";
    case 5:
      return "RD";
    case 6:
      return "G";

    default:
      return "LW";
  }
};

export interface HockeyPlayerIdToLabelProps {
  labelType: HockeyPlayerLabelType;
}

export const getHockeyPlayerLabel = ({ labelType }: HockeyPlayerIdToLabelProps): ((playerId: number) => string) => {
  switch (labelType) {
    case "FD":
      return getHockeyPlayerFDLabel;

    case "LR":
      return getHockeyPlayerLRLabel;
  }
};
